import { render, staticRenderFns } from "./goodsMovement.vue?vue&type=template&id=38488f7f&"
import script from "./goodsMovement.vue?vue&type=script&lang=js&"
export * from "./goodsMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports